// lib/autoUpdate.js — v119.220 التحديث التلقائي الفوري:
// يفحص كل فترة (وعند العودة للتبويب) هل صدرت نسخة جديدة من التطبيق،
// وإذا وجدها يعيد تحميل الصفحة تلقائياً — فلا يعلق أي مستخدم على نسخة قديمة.
const CHECK_EVERY_MS = 5 * 60 * 1000; // كل 5 دقائق
const KEY = "tw_last_reload_bundle";

function currentBundle() {
  const s = Array.from(document.scripts).find((x) => /\/static\/js\/main\.[^/]+\.js/.test(x.src || ""));
  return s ? (s.src.match(/main\.[^/]+\.js/) || [null])[0] : null;
}

async function latestBundle() {
  const res = await fetch(`/index.html?nocache=${Date.now()}`, { cache: "no-store" });
  if (!res.ok) return null;
  const html = await res.text();
  return (html.match(/main\.[^/"']+\.js/) || [null])[0];
}

async function checkOnce() {
  try {
    // v144 — لا تعد التحميل أثناء العودة من دخول Google (يجهض تبادل الجلسة)
    if ((window.location.hash || "").includes("session_id=")) return;
    const cur = currentBundle();
    if (!cur) return; // بيئة التطوير — لا شيء
    const latest = await latestBundle();
    if (!latest || latest === cur) return;
    if (localStorage.getItem(KEY) === latest) return; // منع حلقة إعادة تحميل
    localStorage.setItem(KEY, latest);
    window.location.reload();
  } catch {
    /* شبكة غير متاحة — نحاول لاحقاً */
  }
}

export function startAutoUpdate() {
  setTimeout(checkOnce, 15 * 1000);
  setInterval(checkOnce, CHECK_EVERY_MS);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") checkOnce();
  });
}
